module.exports = __webpack_public_path__ + "img/UsgsBlueSymbol.e53b56b9.svg";